import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=38dd7a70&scoped=true&"
import script from "./BaseLayout.vue?vue&type=script&lang=ts&"
export * from "./BaseLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dd7a70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/app-root/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38dd7a70')) {
      api.createRecord('38dd7a70', component.options)
    } else {
      api.reload('38dd7a70', component.options)
    }
    module.hot.accept("./BaseLayout.vue?vue&type=template&id=38dd7a70&scoped=true&", function () {
      api.rerender('38dd7a70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/GPortal/Frontend/vue/view/app/BaseLayout.vue"
export default component.exports